import { useTranslations } from '@vocab/react';
import { Dialog, Inline, Button, Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
}

export const DiscardDialog = ({ isOpen, onClose, onDiscard }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Dialog
      id="discard-changes-dialog"
      title={t('discard-changes-dialog-title')}
      description={
        <Text tone="secondary">{t('discard-changes-dialog-description')}</Text>
      }
      open={isOpen}
      onClose={onClose}
      width="small"
    >
      <Inline space="small" reverse collapseBelow="tablet">
        <Button
          tone="formAccent"
          onClick={onDiscard}
          data={{ testid: 'discard-changes-button' }}
        >
          {t('discard-changes-button-label')}
        </Button>
        <Button
          tone="formAccent"
          variant="ghost"
          onClick={onClose}
          data={{ testid: 'keep-editing-button' }}
        >
          {t('keep-editing-button-label')}
        </Button>
      </Inline>
    </Dialog>
  );
};
